import Start from './start';
import Data from './data';
import Word from './words';
import State from './state';


document.addEventListener('DOMContentLoaded', () => {
  const start = new Start();
  start.bindEvents();

  const words = new Word();
  words.renderWord(0);

  const events = new State();
  events.callEvents();
});
